import { createApiClient } from '@terra/api-client';

import { API_BASE_URL } from './appUrls';

/** Singleton API client for the admin console. Access token in memory; refresh via httpOnly cookie. */
export const api = createApiClient({
  baseURL: API_BASE_URL,
  withCredentials: true,
  onAuthFailure: () => window.dispatchEvent(new CustomEvent('terra:auth-expired')),
});
